import { useCsAttribute } from "./useCsAttribute";
function isValidValue(value) {
    return Boolean((value === null || value === void 0 ? void 0 : value.isAllowed) && (value === null || value === void 0 ? void 0 : value.isActive));
}
export function useSingleOptionBoolValue() {
    var _a;
    const attribute = useCsAttribute();
    const values = (_a = attribute.values) !== null && _a !== void 0 ? _a : [];
    const trueValue = values.find((v) => v.value === true);
    const falseValue = values.find((v) => v.value === false);
    const hasSelection = Boolean((trueValue === null || trueValue === void 0 ? void 0 : trueValue.isSelected) || (falseValue === null || falseValue === void 0 ? void 0 : falseValue.isSelected));
    const singleValue = isValidValue(trueValue)
        ? trueValue
        : isValidValue(falseValue)
            ? falseValue
            : (trueValue !== null && trueValue !== void 0 ? trueValue : falseValue);
    return {
        trueValue,
        falseValue,
        singleValue,
        hasSelection,
    };
}
//# sourceMappingURL=useSingleOptionBoolValue.js.map